export interface CompletedSteps {
  selectClinic: boolean;
  selectTreatment: boolean;
  selectDateAndTime: boolean;
  verifyPhone: boolean;
  selectContactDetails: boolean;
}

/**
 * The ContactDetails dialog step consists of three sub-steps, in this order:
 * - `emailAndPhone`: entering the email and phone number to verify
 * - `verifySms`: entering the code sent by SMS (skipped for existing users)
 * - `details`: entering the rest of the contact details (client and patient information)
 */
export type ContactDetailsSubStep = "emailAndPhone" | "verifySms" | "details";

/**
 * Determines which sub-step of the ContactDetails step the user is on. The phone
 * verification is shown until it has been completed, then the rest of the contact details.
 * @param completedSteps - The completed steps of the booking flow
 * @param awaitingSmsCode - Whether the SMS code has been sent, and is waiting to be entered
 */
export const getContactDetailsSubStep = (
  completedSteps: Pick<CompletedSteps, "verifyPhone">,
  awaitingSmsCode: boolean = false
): ContactDetailsSubStep => {
  if (completedSteps.verifyPhone) {
    return "details";
  }

  return awaitingSmsCode ? "verifySms" : "emailAndPhone";
};
